import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { SalesTask } from "../../../core/models/careplan.models";

@Injectable({
    providedIn: "root",
})
export class SalesTaskUpdatesService {
    constructor() {
    }

    private _salesTaskUpsertSubject: Subject<SalesTask> = new Subject<SalesTask>();
    private _salesTaskDeleteSubject: Subject<SalesTask> = new Subject<SalesTask>();

    public get salesTaskUpsertSubject$(): Subject<SalesTask> {
        return this._salesTaskUpsertSubject;
    }

    public get salesTaskDeleteSubject$(): Subject<SalesTask> {
        return this._salesTaskDeleteSubject;
    }

    public upsertSalesTask(salesTask: SalesTask) {
        this._salesTaskUpsertSubject.next(salesTask);
    }

    public deleteSalesTask(salesTask: SalesTask) {
        this._salesTaskDeleteSubject.next(salesTask);
    }
}
